export default __webpack_public_path__ + "static/media/dds5168b-6.fc318622.png";